var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters, mapActions } from 'vuex';
import { ACCOUNT_CHECKOUT, ACCOUNT, LOCATION } from '@/stores/defs';
import { formatNumber, isValidNumber } from 'libphonenumber-js';
import customerService from '@/services/customer.service';
import EventBus from '@EventBus';
import phoneValidatorMixin from '@/components/mixins/phoneValidatorMixin';
var mixinName = {
    mixins: [
        phoneValidatorMixin,
    ],
    data: function () {
        return {
            guestNameModel: '',
            guestEmailModel: '',
        };
    },
    computed: __assign({}, mapGetters({
        isGuest: ACCOUNT_CHECKOUT.GET_IS_GUEST,
        guestId: ACCOUNT_CHECKOUT.GET_GUEST_ID,
        guestPhone: ACCOUNT.GET_GUEST_PHONE,
        guestEmail: ACCOUNT.GET_GUEST_EMAIL,
        guestName: ACCOUNT.GET_GUEST_NAME,
        customer: ACCOUNT.GET_CUSTOMER,
        loggedIn: ACCOUNT.GET_LOGGED_IN,
        location: LOCATION.GET_LOCATION,
    }), { hasCustomer: function () {
            var hasCustomer = this.customer.exists();
            return hasCustomer;
        },
        customerName: function () {
            var name = this.customer.firstName;
            return name;
        },
        displayName: function () {
            var isGuest = this.isGuest;
            var hasCustomer = this.hasCustomer;
            if (hasCustomer) {
                return "" + this.customerName;
            }
            if (isGuest) {
                return 'Guest';
            }
        } }),
    methods: __assign({}, mapActions({
        setIsGuest: ACCOUNT_CHECKOUT.SET_IS_GUEST,
        setGuestId: ACCOUNT_CHECKOUT.SET_GUEST_ID,
        setGuestPhone: ACCOUNT.SET_GUEST_PHONE,
        setGuestEmail: ACCOUNT.SET_GUEST_EMAIL,
        setGuestName: ACCOUNT.SET_GUEST_NAME,
        updateCustomer: ACCOUNT.UPDATE_CUSTOMER,
    }), { updatePhone: function (phone) {
            this.updateCustomer({
                phone: phone,
            });
            this.saveProperties();
        },
        updateEmail: function (email) {
            this.updateCustomer({
                email: email,
            });
            this.saveProperties();
        },
        updateName: function (name) {
            this.updateCustomer({
                firstName: name,
            });
            this.saveProperties();
        },
        validateClass: function (value) {
            var style = {};
            style[value] = true;
            return style;
        },
        updatePhoneClass: function () {
            var valid = this.hasValidPhone(this.guestPhone);
            return valid;
        },
        saveProperties: function () {
            var _this = this;
            var apiReq = {
                lb: this.location.id,
                cmd: 'guest_update',
                c: {
                    base: this.guestId,
                    phone: this.guestPhone,
                    email: this.guestEmail,
                    firstname: this.guestName,
                    receiveOffers: false,
                }
            };
            customerService.editProfile(apiReq).then(function (response) {
                // Guest saved
                _this.errorMessage = '';
                EventBus.$emit('guest-saved', response);
            }).catch(function (err) {
                console.error("Error saving guest information: " + err);
                EventBus.$emit('guest-error', err);
            });
        },
        _setGuestAsDefault: function () {
            var customer = this.customer;
            var isCustomer = customer.exists();
            if (isCustomer) {
                return;
            }
            this.setIsGuest(true);
        } }),
    watch: {
        guestEmailModel: function (newValue, oldValue) {
            if (newValue !== oldValue) {
                this.setGuestEmail(newValue);
            }
        },
        guestNameModel: function (newValue, oldValue) {
            if (!newValue) {
                return;
            }
            if (newValue !== oldValue) {
                if (newValue.trim() === '') {
                    this.setGuestName('-');
                    return;
                }
                this.setGuestName(newValue);
            }
        },
        phone: function (newValue, oldValue) {
            if (newValue !== oldValue) {
                var newIsValid = isValidNumber(newValue);
                var oldIsValid = oldValue && isValidNumber(oldValue);
                if (newIsValid && oldIsValid) {
                    return;
                }
                var formatted = newValue;
                if (!newIsValid && newValue !== '') {
                    formatted = formatNumber(newValue, 'US', 'National');
                }
                this.setGuestPhone(formatted);
            }
        }
    },
};
export default mixinName;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/contactDetailsMixin.ts
// module id = ylut
// module chunks = 18